export function callSideEffects(fx, params) {
    if (!fx) {
        return;
    }
    fx.forEach((fn) => {
        return fn(params);
    });
}
